import { useMemo } from 'react';
import { formatCurrencyValueWithSpaces } from 'shared/utils/helpers';

export const usePrizeFundFormatting = (amount: string | number) => {
  const formattedAmount = useMemo(() => {
    return formatCurrencyValueWithSpaces(Number(amount));
  }, [amount]);

  return {
    formattedAmount,
  };
};
